import type { REGIONS_DATA } from '../../constants';

export type RegionName = (typeof REGIONS_DATA)[number]['region'];

export const LOCATION_MAP: Record<RegionName, { className: string }> = {
  강원: { className: 'absolute top-[22px] left-[193px] w-[61px] h-[73px]' },
  충북: { className: 'absolute top-[105px] left-[167px] w-[61px] h-[73px]' },
  충남: { className: 'absolute top-[139px] left-[54px] w-[61px] h-[73px]' },
  대전: { className: 'absolute top-[185px] left-[146px] w-[61px] h-[73px]' },

  경북: { className: 'absolute top-[186px] left-[241px] w-[61px] h-[73px]' },
  경남: { className: 'absolute top-[268px] left-[178px] w-[61px] h-[73px]' },
  전남: { className: 'absolute top-[335px] left-[8px] w-[61px] h-[73px]' },

  전북: { className: 'absolute top-[241px] left-[82px] w-[61px] h-[73px]' },
  광주: { className: 'absolute top-[325px] left-[84px] w-[61px] h-[73px]' },
  제주: { className: 'absolute top-[435px] left-[39px] w-[61px] h-[73px]' },
};

export const ONBOARDING_SEQUENCE: readonly RegionName[] = [
  '제주',
  '전남',
  '광주',
  '전북',
  '충남',
  '대전',
  '충북',
  '경남',
  '경북',
  '강원',
];

export const COMPLETED_DONATION_COUNT = 10;
